module.exports = __webpack_public_path__ + "static/img/001.e01ec0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/qualification/001.png
// module id = 0Kcb
// module chunks = 0